export default "__VITE_ASSET__$dvRr6Xe__"